module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/reply-all-5a5651aa85c4b14a06f9505ef4e1a7b0.svg";